import { useMutation } from '@apollo/client';
import { css } from '@emotion/css';
import { DELETE_ACCOUNT } from '@repo-sapiens/graphql';
import { AppButton, Dialog, Separator, Text } from '../../../components';
import { GameOverIllustration1 } from '../../../components/icons';
import React from 'react';
import { E_Route } from '@repo-sapiens/constants';

type Props = {
  children: React.ReactNode;
};
export const DeleteDialog: React.FC<Props> = ({ children }) => {
  const [open, onOpenChange] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);
  const [deactivate] = useMutation(DELETE_ACCOUNT);
  const handleDeactivate = () => {
    if (deleting) return; // Prevent multiple clicks
    setDeleting(true);
    deactivate()
      .then(() => {
        setDeleting(false);
        window.location.href = E_Route.AuthBegin;
      })
      .catch((error) => {
        setDeleting(false);
        console.error('Error deactivating account:', error);
      });
  };
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      additionalContent={
        <div
          className={css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `}
        >
          <GameOverIllustration1 />
          <div
            className={css`
              width: 60%;
              margin-bottom: 24px;
            `}
          >
            <Text.Body
              style={{
                color: '#909090',
                textAlign: 'center',
              }}
            >
              You are about to delete Multiplayer. This will delete all your
              data. Are you sure?
            </Text.Body>
          </div>
          <AppButton onClick={handleDeactivate} disabled={deleting}>
            Yes, delete my data
          </AppButton>
          <Separator.Horizontal spacing={1} />
          <AppButton
            disabled={deleting}
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Cancel
          </AppButton>
        </div>
      }
    >
      <div
        className={css`
          width: 100%;
        `}
      >
        {children}
      </div>
    </Dialog>
  );
};
